import { Card, Col, Row } from "react-bootstrap";

import { InvoiceState } from "../../../types/invoice";
import styled from "styled-components";
import { formatAmount } from "../../../utils/amount";
import { HorizontalDivider } from "../../../common/components/core";
import HousingRulesText from "../../payment/components/HousingRulesText";
import { PreAndPaymentStateWithDocuments } from "../../../types/payment";

type PaymentOrderAndInvoiceDetailCardProps = {
    className?: string;
    preAndPayment: PreAndPaymentStateWithDocuments;
    invoice: InvoiceState;
};

const PaymentOrderAndInvoiceDetailCard = ({
    className,
    preAndPayment,
    invoice,
}: PaymentOrderAndInvoiceDetailCardProps): JSX.Element => {
    const { paymentOrderState } = preAndPayment;
    return (
        <Card className={`mb-5 border-0 ${className || ""}`}>
            <Card.Body className={"p-0"}>
                <dl>
                    <div>
                        <h2 className="mb-3">Payment Details</h2>
                        <p className="mb-1 mt-1">
                            <dd>
                                <span className="h1">
                                    {formatAmount(
                                        paymentOrderState.props.instructedMVUnit,
                                    )}
                                </span>
                                <span className="ms-2 fw-bold">
                                    {paymentOrderState.props.instructedMVCurrency}
                                </span>
                            </dd>
                        </p>
                        <dt><p className="text-label-grey mb-3">Payable Amount</p></dt>
                    </div>
                    <HorizontalDivider />
                    <div>
                        <StyledH3 className={"mt-2 mb-2"}>Payer Details</StyledH3>
                        <HorizontalDivider />
                        <Row xs={2}>
                            <Col className="border-end border-humble-grey">
                                <dt>
                                    <StyledLabel className="mt-2 mb-2">
                                        Payer Bank Account{" "}
                                    </StyledLabel>
                                </dt>
                                {!paymentOrderState.props.fromAccount
                                    ?.accountName &&
                                !paymentOrderState.props.fromAccount
                                    ?.accountNumber ? (
                                    <dd><p className="fw-bold">-</p></dd>
                                ) : (
                                    <dd>
                                        <p className="fw-bold mb-0">
                                            {
                                                paymentOrderState.props.fromAccount
                                                    ?.accountName
                                            }
                                        </p>
                                        <p className="fw-bold">
                                            {
                                                paymentOrderState.props.fromAccount
                                                    ?.accountNumber
                                            }
                                        </p>
                                    </dd>
                                )}
                            </Col>
                            <Col className="border-end border-humble-grey">
                                <dt>
                                    <StyledLabel className="mt-2 mb-2">
                                        Payer Bank
                                    </StyledLabel>
                                </dt>
                                {!paymentOrderState.props.fromAccount?.bic &&
                                !paymentOrderState.props.payer?.legalName ? (
                                    <dd><p className="fw-bold">-</p></dd>
                                ) : (
                                    <dd>
                                        <p className="fw-bold">
                                            {paymentOrderState.props.fromAccount?.bic} -{" "}
                                            {paymentOrderState.props.payer.legalName}
                                        </p>
                                    </dd>
                                )}
                            </Col>
                        </Row>
                        <HorizontalDivider />
                        <div className="my-3">
                            <dt>
                                <StyledLabel className="mt-2 mb-2">
                                    Housing Rules Type
                                </StyledLabel>
                            </dt>
                            <div className="mb-5">
                                <dd>
                                    <HousingRulesText
                                        className="fw-bold"
                                        rules={paymentOrderState.props.bankInformation}
                                    />
                                </dd>
                            </div>
                        </div>
                    </div>
                    <HorizontalDivider />
                    <div>
                        <StyledH3 className={"mt-2 mb-2"}>Beneficiary Details</StyledH3>
                        <HorizontalDivider />
                        <Row xs={2}>
                            <Col className="border-end border-humble-grey">
                                <dt>
                                    <StyledLabel className="mt-2 mb-2">
                                        Beneficiary Bank Account
                                    </StyledLabel>
                                </dt>
                                <dd>
                                    <p className="fw-bold mb-0">
                                        {
                                            invoice.props.bankAccountDetails
                                                .bankAccountHolderName
                                        }
                                    </p>
                                    <p className="fw-bold">
                                        {
                                            invoice.props.bankAccountDetails
                                                .bankAccountNumberStr
                                        }
                                    </p>
                                </dd>
                            </Col>
                            <Col className="border-end border-humble-grey">
                                <dt>
                                    <StyledLabel className="mt-2 mb-2">
                                        {" "}
                                        Beneficiary Bank
                                    </StyledLabel>
                                </dt>
                                <dd>
                                    <p className="fw-bold">
                                        {invoice.props.bankAccountDetails.swiftAddress}{" "}
                                        - {invoice.props.bankAccountDetails.bankName}
                                    </p>
                                </dd>
                            </Col>
                        </Row>
                        <HorizontalDivider />
                    </div>
                </dl>
            </Card.Body>
        </Card>
    );
};

const StyledH3 = styled.h3`
    margin: 2rem 0;
    color: var(--bs-body-color);
`;
const StyledLabel = styled.p`
    // font-size: 10px;
    color: var(--bs-label-grey);
`;


export default PaymentOrderAndInvoiceDetailCard;
